import MiniStatisticsCard from "examples/Cards/StatisticsCards/MiniStatisticsCard";
import { BsBank } from "react-icons/bs";
import { QuickBooksAccountSummary } from "services/QuickBooksService";

interface Props {
  account: QuickBooksAccountSummary;
  loading: boolean;
  currency: string;
}

export const QuickBooksAccountCard = ({
  account,
  loading,
  currency,
}: Props) => {

  return (
    <MiniStatisticsCard
      title={{ text: account.accountName, fontWeight: "bold" }}
      count={account.balance.value.toLocaleString("en-US", {
        style: "currency",
        currency: currency,
      })}
      icon={<BsBank color="white" />}
      loading={loading}
    />
  );
}; 